"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoginForm_1 = __importDefault(require("./LoginForm"));
const LabelledInput_1 = __importDefault(require("./LabelledInput"));
const react_tiny_spin_1 = __importDefault(require("react-tiny-spin"));
function Invitation(props) {
    const [businessName, setBusinessName] = react_1.default.useState(null);
    const [firstName, setFirstName] = react_1.default.useState('');
    const [lastName, setLastName] = react_1.default.useState('');
    const [password, setPassword] = react_1.default.useState('');
    const [loading, setLoading] = react_1.default.useState(false);
    const [error, setError] = react_1.default.useState(null);
    react_1.default.useLayoutEffect(() => {
        setLoading(true);
        props.endpointService.getUserDetailsFromInvitationToken(props.token)
            .then(data => {
            setFirstName(data.first_name);
            setLastName(data.last_name);
            setBusinessName(data.business_name);
        })
            .catch(err => {
            console.error(err);
            setError(err);
        })
            .then(() => {
            setLoading(false);
        });
        // only do once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: what are the rules for password strength?
    const isValid = firstName.trim().length > 0
        && lastName.trim().length > 0
        && password.length >= 8;
    const onSubmit = () => {
        setLoading(true);
        props.endpointService.activateUser({
            invitation_token: props.token,
            first_name: firstName,
            last_name: lastName,
            password,
        })
            .then(loginToken => {
            window.location.href = `/?token=${loginToken.token}`;
        })
            .catch(err => {
            // TODO: handle this error differently
            setError(err);
            setLoading(false);
        });
    };
    return (react_1.default.createElement(LoginForm_1.default, { onSubmit: onSubmit, title: "Invitation to RealTime CEO", footer: (react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-xs-12 text-center" },
                react_1.default.createElement("a", { className: "login-link", onClick: () => props.onCancel() }, "Back to Login")))) },
        react_1.default.createElement("div", { style: { minHeight: '200px' } },
            error && (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, "This invitation isn't valid, it might have expired."),
                react_1.default.createElement("p", null,
                    "If you've already set up your account, ",
                    react_1.default.createElement("a", { href: "/login" }, "log in here.")),
                react_1.default.createElement("p", null, "Otherwise, contact the manager of your RealTime CEO account to have a new invitation sent."))),
            !error && !loading && (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "Confirm your details and choose a password to finish setting up your account with ",
                    react_1.default.createElement("strong", null, businessName),
                    "."),
                react_1.default.createElement("hr", null),
                react_1.default.createElement(LabelledInput_1.default, { name: "First Name", value: firstName, onChange: setFirstName, type: "text" }),
                react_1.default.createElement(LabelledInput_1.default, { name: "Last Name", value: lastName, onChange: setLastName, type: "text" }),
                react_1.default.createElement(LabelledInput_1.default, { name: "Password", value: password, onChange: setPassword, type: "password" }),
                react_1.default.createElement("div", { className: "row row-10m" },
                    react_1.default.createElement("div", { className: "col-xs-4 col-xs-offset-4 text-center" },
                        react_1.default.createElement("button", { type: "submit", className: "btn btn-login btn-action", disabled: !isValid }, "Register"))))),
            loading && (react_1.default.createElement(react_tiny_spin_1.default, { config: {
                    width: 12,
                    radius: 35,
                } })))));
}
exports.default = Invitation;
